export const CATEGORIES_LOAD = 'CATEGORIES_LOAD';
export const CATEGORIES_LOAD_SUCCESS = 'CATEGORIES_LOAD_SUCCESS';
export const CATEGORIES_LOAD_ERROR = 'CATEGORIES_LOAD_ERROR';

export const CATEGORIES_ADD = 'CATEGORIES_ADD';
export const CATEGORIES_ADD_SUCCESS = 'CATEGORIES_ADD_SUCCESS';
export const CATEGORIES_ADD_ERROR = 'CATEGORIES_ADD_ERROR';

export const CATEGORIES_UPDATE = 'CATEGORIES_UPDATE';
export const CATEGORIES_UPDATE_SUCCESS = 'CATEGORIES_UPDATE_SUCCESS';
export const CATEGORIES_UPDATE_ERROR = 'CATEGORIES_UPDATE_ERROR';

export const CATEGORIES_DELETE = 'CATEGORIES_DELETE';
export const CATEGORIES_DELETE_SUCCESS = 'CATEGORIES_DELETE_SUCCESS';
export const CATEGORIES_DELETE_ERROR = 'CATEGORIES_DELETE_ERROR';